import commonMiddlewares from "src/control/middlewares/commons";
import modelTrainingMiddlewares from "src/control/middlewares/modelTraining/model_training_middlewares";
import configPanelMiddlewares from "src/control/middlewares/configPanel/config_panel_middlewares";

export default [
    ...commonMiddlewares,
    ...modelTrainingMiddlewares,
    ...configPanelMiddlewares

]